import React, { Component } from 'react';
import { browserHistory, Link } from 'react-router';
import classNames from 'classnames';
import _ from 'lodash';
import {
  storeUser,
  getUser,
  getServerUrl,
  dynamicSort,
  getStoreLastVisitedRoute,
  userLogout,
  storeLastVisitedRoute,
  storeSyncInventoryDate,
  storeInventoryFlag,
  storeDERFlag,
  getDERFlag,
  getTerritoryData,
  getTeamData,
  storeVersionCode,
  getThemeColor,
  getThemeColorNumber,
  storeThemeColor,
  storeThemeColorNumber,
} from '../common/globals';
import {
  saveScanInventoryData,
  signout
} from '../utils/utils';
import withMenu from '../common/withMenu';
import withUser from '../common/withUser';
import withServerUrl from '../common/withServerUrl';
import withLoader from '../common/withLoader';
import withNotify from '../common/withNotify';
import withOnline from '../common/withOnline';
import withTeam from '../common/withTeam';
import withCalendarFilter from '../common/withCalendarFilter';
import withSelectCaseDate from '../common/withSelectCaseDate';
import withCaseFilter from '../common/withCaseFilter';
import Bugsnag from '../helpers/bugsnag';
import {
  deleteDb,
  getInventory,
  getNotSyncdCases,
  updateInventoryByLocalInventoryId,
  getUnSubmittedScanSessions,
  deleteAllCases,
  deleteOfflineSyncCases,
  deleteUnSubmittedScanSessions,
  deleteInventoryData,
  deleteInventoryScansData
} from '../utils/db';
import withScanInventory from '../common/withScanInventory';
import withFirstLoginSessionToken from '../common/withFirstLoginSessionToken';
import withScanInventoryScanner from '../common/withScanInventoryScanner';
import withUpdatedRoute from '../common/withUpdatedRoute';
import { APP_VERSION } from '../common/config';
import withAutoLogin from '../common/withAutoLogin';
import withThemeColor from '../common/withThemeColor';

class Sidebar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      user: {},
      offices: [],
      menuVisible: true,
      lastVisitedRoute: '',
      hasNotifications: false,
      mailBody: '',
      selectedOfficeName: '',
    };
    this.logoutConfirmModal = null;
    this.unSavedCasesCofirmation = null;
    this.unSubmittedScanSessions = null;
    this.unSavedCaseChanges = null;
  }

  componentDidMount() {
    try {
      this.logoutConfirmModal = new window.bootstrap.Modal(window.$('#logoutConfirmationModal'), {});
      this.unSavedCasesCofirmation = new window.bootstrap.Modal(window.$('#unSavedDataConfirmationModal'));
      this.unSubmittedScanSessions = new window.bootstrap.Modal(window.$('#unSubmittedScanSessionsModal'));
      this.unSavedCaseChanges = new window.bootstrap.Modal(window.$('#unSavedCaseChangesModal'));
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onClickTeam = async (
    territoryId,
    office, team,
    selectedTeam,
    isOpenLogoutModal,
    isChangeTeam,
    isSyncData = false
  ) => {
    try {
      const {
        user, setUser, setLoader, online, setTeam, setSelectCaseDate, setCaseFilter,
        setCalendarFilter
      } = this.props;
      if (isOpenLogoutModal) {
        this.logoutConfirmModal.show();
        return;
      }
      const notSyncData = await getNotSyncdCases();
      if (notSyncData !== undefined && notSyncData.length > 0 && isChangeTeam) {
        setTeam(selectedTeam);
        this.unSavedCasesCofirmation.show();
        return;
      }
      const userData = Object.assign(user, {
        office, team, selectedTeam, territoryId
      });

      // Store territories data from userData
      const territoriesData = userData.territories;
      territoriesData.map((t1) => {
        if (territoryId === t1.id) {
          storeDERFlag(t1.isDER);
        }
      });

      const offices = [];
      user.territories.map((item) => {
        item.offices.map(async (value) => {
          // Sort team asc order
          value.teams.sort(dynamicSort('name'));

          offices.push(Object.assign(value, {
            abb: item.abb,
            connectionStringApi: item.connectionStringApi,
            httpUrlApiNew: item.httpUrlApiNew,
            territoryId: item.id,
            territoryName: item.name,
            server: item.server
          }));
        });
      });
      if (offices.length === 1) {
        offices.map((value) => {
          if (value.teams.length === 1) {
            this.setState({
              menuVisible: false
            });
          }
        });
      }
      const sortOffices = _.sortBy(offices, 'name');
      // if (online) {
      //   const getUserRes = await getUsersSettings(user.id);
      //   if (Object.keys(getUserRes).length > 0) {
      //     userData.isBigCards = getUserRes.isBigCards;
      //     userData.isGroupByHospital = getUserRes.isGroupByHospital;
      //     userData.isPushNotifications = getUserRes.isPushNotifications;
      //   }
      // }
      setUser(userData);
      storeUser(userData);
      storeVersionCode();
      this.setState({ user, offices: sortOffices, changeTeam: selectedTeam });
      if (online) {
        if (isSyncData || (isChangeTeam && notSyncData.length === 0)) {
          setLoader(true);
          await deleteInventoryData();
          await deleteInventoryScansData();
          setSelectCaseDate({});
          setCaseFilter({});
          setCalendarFilter({});
          storeSyncInventoryDate('');
          storeInventoryFlag('false');
          browserHistory.push('/sync-data');
          setLoader(false);
        }
      }
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onLogout = async () => {
    try {
      const {
        setLoader, setCalendarFilter, setTeam, setScanInventory, setFirstLoginSessionToken,
        setScanInventoryScanner, online, setUpdatedRoute, setCaseFilter
      } = this.props;
      const getNotSyncedCases = await getNotSyncdCases();
      const unSubmittedScanSessions = await getUnSubmittedScanSessions();

      const color = await getThemeColor();
      const colorNumber = await getThemeColorNumber();

      // setLoader(true);
      if (online) {
        if (unSubmittedScanSessions !== undefined && unSubmittedScanSessions.length > 0
          && getNotSyncedCases !== undefined && !getNotSyncedCases.length > 0) {
          this.unSubmittedScanSessions.show();
          return;
        }

        if (getNotSyncedCases !== undefined && getNotSyncedCases.length > 0
          && unSubmittedScanSessions !== undefined
          && !unSubmittedScanSessions.length > 0) {
          this.unSavedCaseChanges.show();
          return;
        }

        if (unSubmittedScanSessions !== undefined
          && unSubmittedScanSessions.length > 0 && getNotSyncedCases !== undefined
          && getNotSyncedCases.length > 0) {
          this.unSavedCaseChanges.show();
          setLoader(false);
        }

        if ((getNotSyncedCases !== undefined && !getNotSyncedCases.length > 0)
          && (unSubmittedScanSessions !== undefined && !unSubmittedScanSessions.length > 0)) {
          setTeam({});
          await deleteDb();
          setCaseFilter({});
          setCalendarFilter({});
          setScanInventory({});
          setScanInventoryScanner({});
          setFirstLoginSessionToken('');
          setUpdatedRoute('');
          signout().then(async () => {
            window.localStorage.clear();
            await storeThemeColor(color);
            await storeThemeColorNumber(colorNumber);

            await userLogout();
            setLoader(false);
          });
        }
      } else if (!online && unSubmittedScanSessions !== undefined
        && unSubmittedScanSessions.length > 0 && getNotSyncedCases !== undefined
        && !getNotSyncedCases.length > 0) {
        this.unSubmittedScanSessions.show();
        setLoader(false);
        // return;
      } else if (!online && getNotSyncedCases !== undefined
        && getNotSyncedCases.length > 0 && unSubmittedScanSessions !== undefined
        && !unSubmittedScanSessions.length > 0) {
        this.unSavedCaseChanges.show();
        setLoader(false);
        // return;
      } else if (!online && unSubmittedScanSessions !== undefined
        && unSubmittedScanSessions.length > 0 && getNotSyncedCases !== undefined
        && getNotSyncedCases.length > 0) {
        this.unSavedCaseChanges.show();
      } else {
        setLoader(true);
        await deleteDb();
        await deleteAllCases();
        await deleteOfflineSyncCases();
        await deleteUnSubmittedScanSessions();

        window.localStorage.clear();
        await storeThemeColor(color);
        await storeThemeColorNumber(colorNumber);

        setTeam({});
        setCaseFilter({});
        setCalendarFilter({});
        setScanInventory({});
        setScanInventoryScanner({});
        setFirstLoginSessionToken('');
        setUpdatedRoute('');
        browserHistory.push('/');
        setLoader(false);
      }
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onClickCases = () => {
    try {
      if (window.location.pathname === '/manage-cases' && window.$('.left-bar').hasClass('is-active')) {
        window.$('.left-bar').removeClass('is-active');
        browserHistory.push('/manage-cases');
      } else {
        browserHistory.push('/manage-cases');
      }
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onClickSalesMetrics = () => {
    try {
      const { online, notify } = this.props;
      if (!online) {
        notify({ type: 'error', message: 'You must have an internet connection to view sales metrics.', time: 5 });
        return;
      }
      if (window.location.pathname === '/sales-metrics' && window.$('.left-bar').hasClass('is-active')) {
        window.$('.left-bar').removeClass('is-active');
        browserHistory.push('/sales-metrics');
      } else {
        browserHistory.push('/sales-metrics');
      }
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onClickBilling = () => {
    try {
      if (window.location.pathname === '/billing' && window.$('.left-bar').hasClass('is-active')) {
        window.$('.left-bar').removeClass('is-active');
        browserHistory.push('/billing');
      } else {
        browserHistory.push('/billing');
      }
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onClickReports = () => {
    try {
      const { online, notify } = this.props;
      if (online) {
        if (window.location.pathname === '/reports' && window.$('.left-bar').hasClass('is-active')) {
          window.$('.left-bar').removeClass('is-active');
          browserHistory.push('/reports');
        } else {
          browserHistory.push('/reports');
        }
      } else {
        notify({ type: 'error', message: 'You must have an internet connection to view reports.', time: 5 });
      }
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onClickInventory = () => {
    try {
      if (window.location.pathname === '/inventory' && window.$('.left-bar').hasClass('is-active')) {
        window.$('.left-bar').removeClass('is-active');
        browserHistory.push('/inventory');
      } else {
        browserHistory.push('/inventory');
      }
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onClickDers = () => {
    try {
      if (window.location.pathname === '/ders' && window.$('.left-bar').hasClass('is-active')) {
        window.$('.left-bar').removeClass('is-active');
        browserHistory.push('/ders');
      } else {
        browserHistory.push('/ders');
      }
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onClickPreferences = () => {
    try {
      if (window.location.pathname === '/preferences' && window.$('.left-bar').hasClass('is-active')) {
        window.$('.left-bar').removeClass('is-active');
        browserHistory.push('/preferences');
      } else {
        browserHistory.push('/preferences');
      }
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onClickSyncData = () => {
    try {
      const { online, notify } = this.props;
      if (online) {
        browserHistory.push('/sync-data');
      } else {
        notify({ type: 'error', message: 'You must have an internet connection to sync data.', time: 5 });
      }
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onClickCalendarFeed = () => {
    try {
      if (window.location.pathname === '/calendar-feed' && window.$('.left-bar').hasClass('is-active')) {
        window.$('.left-bar').removeClass('is-active');
        browserHistory.push('/calendar-feed');
      } else {
        browserHistory.push('/calendar-feed');
      }
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onClickNotifications = () => {
    try {
      const { online, notify } = this.props;
      if (online) {
        if (window.location.pathname === '/notifications' && window.$('.left-bar').hasClass('is-active')) {
          window.$('.left-bar').removeClass('is-active');
          browserHistory.push('/notifications');
        } else {
          browserHistory.push('/notifications');
        }
      } else {
        notify({ type: 'error', message: 'You must have an internet connection to view notifications.', time: 5 });
      }
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onClickSettings = () => {
    try {
      const { online, notify } = this.props;
      if (online) {
        if (window.location.pathname === '/settings' && window.$('.left-bar').hasClass('is-active')) {
          window.$('.left-bar').removeClass('is-active');
          browserHistory.push('/settings');
        } else {
          browserHistory.push('/settings');
        }
      } else {
        notify({ type: 'error', message: 'You must have an internet connection to view settings.', time: 5 });
      }
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onChangeTeam = (
    territoryId,
    office,
    team, selectedTeam, isOpenLogoutModal, isChangeTeam, isSyncData
  ) => {
    try {
      const { online, notify } = this.props;
      if (online) {
        this._onClickTeam(territoryId,
          office,
          team,
          selectedTeam,
          isOpenLogoutModal,
          isChangeTeam,
          isSyncData);
      } else {
        notify({ type: 'error', message: 'You must have an internet connection to change the team.' });
      }
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _saveInventory = async () => {
    try {
      const { online, notify } = this.props;
      const inventoryRes = await getInventory();
      if (online) {
        let responseJson = {};
        const hospitalPromiseAll = inventoryRes.map(async (data) => new Promise(
          // eslint-disable-next-line no-async-promise-executor
          async (resolve) => {
            if (data.ID === null) {
              responseJson = await saveScanInventoryData(data);
              const { message, status, ID } = responseJson;
              if (status) {
                data.ID = ID;
                await updateInventoryByLocalInventoryId(data.inventoryId, data);
              } else {
                notify({ type: 'error', message, time: 3 });
              }
            }
            resolve(true);
          }
        ));
        await Promise.all(hospitalPromiseAll);
      }
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _getLastVisitedRoute = async () => {
    try {
      const { setUpdatedRoute } = this.props;
      const getNotSyncedCases = await getNotSyncdCases();
      if (getNotSyncedCases !== undefined && !getNotSyncedCases.length > 0) {
        const lastVisitedRoute = await getStoreLastVisitedRoute();
        setUpdatedRoute(lastVisitedRoute);
        this.setState({ lastVisitedRoute });
      }
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onClickYes = async () => {
    try {
      const {
        setTeam, setLoader, setCalendarFilter, setScanInventory, setScanInventoryScanner,
        setFirstLoginSessionToken, setUpdatedRoute, online, setCaseFilter
      } = this.props;
      if (online) {
        setLoader(true);
        storeLastVisitedRoute('');
        setUpdatedRoute('');
        setTeam({});
        await deleteDb();
        window.localStorage.clear();
        setCalendarFilter({});
        setScanInventory({});
        setScanInventoryScanner({});
        setFirstLoginSessionToken('');
        setCaseFilter({});
        browserHistory.push('/');
        signout().then(async () => {
          await userLogout();
          setLoader(false);
        });
      } else {
        storeLastVisitedRoute('');
        setUpdatedRoute('');
        setTeam({});
        setCaseFilter({});
        await deleteDb();
        window.localStorage.clear();
        setCalendarFilter({});
        setScanInventory({});
        setScanInventoryScanner({});
        setFirstLoginSessionToken('');
        browserHistory.push('/');
        setLoader(false);
      }
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _getDERFlagValue = async () => {
    try {
      const isDER = await getDERFlag();
      this.setState({ isDER });
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onClickSurgeonNotes = () => {
    try {
      if (window.location.pathname === '/surgeon-notes' && window.$('.left-bar').hasClass('is-active')) {
        window.$('.left-bar').removeClass('is-active');
        browserHistory.push('/surgeon-notes');
      } else {
        browserHistory.push('/surgeon-notes');
      }
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  async UNSAFE_componentWillMount() {
    try {
      const { setServerUrl } = this.props;
      const user = await getUser();
      const serverUrl = await getServerUrl();
      this._getLastVisitedRoute();
      this._getDERFlagValue();
      setServerUrl(serverUrl);
      await this._onClickTeam(user.territoryId, user.office, user.team, user.selectedTeam);
      setTimeout(async () => {
        await this._saveInventory();
      }, 5000);

      user.territories.map((item) => {
        if (item.id === user.territoryId) {
          if (item.hasOwnProperty('offices')) {
            item.offices.map((office) => {
              if (office.id === user.office) {
                this.setState({
                  selectedOfficeName: office.name
                });
              }
            });
          }
        }
      });

      const mailtoLink = 'mailto:OPtimize@kplogic.com?subject=OPtimize Support Ticket&body='
        + `USERID: ${encodeURIComponent(user.userId)}%0D%0A EMAIL: ${encodeURIComponent(user.email)}%0D%0A TERR: ${encodeURIComponent(this.state.selectedOfficeName)}; ${encodeURIComponent(user.selectedTeam.name)}%0D%0A VERSION: ${encodeURIComponent(APP_VERSION)}`;

      this.setState({
        mailBody: mailtoLink
      });
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  render() {
    const {
      menu,
      serverUrl,
      updatedRoute,
      totalUnread,
      themeColor,
    } = this.props;
    const {
      user,
      offices,
      menuVisible,
      isDER,
      mailBody
    } = this.state;

    const accessObject = {};
    if (Object.keys(user).length) {
      const territoryData = getTerritoryData(user);
      const teamData = getTeamData(user);
      accessObject.isSalesMetrics = territoryData?.isSalesMetrics;
      accessObject.salesAccess = teamData?.salesAccess;
    }

    return (
      <>
        <div className="left-bar">
          <div className="header">
            <div className="row">
              <div className="col">
                <Link
                  className="close cursor-pointer" onClick={() => {
                    window.$('#sideMenuTeamsListEle').attr('aria-expanded') === 'true' && window.$('#sideMenuTeamsListEle').click();
                  }}
                >
                  <i className="fas fa-chevron-left ms-0 me-1" /> Back
                </Link>
              </div>
              <div className="col">
                <div className="logo">
                  <Link>
                    {
                      themeColor === 'light'
                        ? (
                          <img
                            src="/assets/images/dark_report_logo.png" alt="logo"
                            onError={(event) => {
                              event.target.src = '/assets/images/dark_report_logo.png';
                              event.onerror = null;
                            }}
                          />
                        )
                        : (
                          <img
                            src="/assets/images/white_report_logo.png" alt="logo"
                            onError={(event) => {
                              event.target.src = '/assets/images/white_report_logo.png';
                              event.onerror = null;
                            }}
                          />
                        )
                    }
                  </Link>
                </div>
              </div>
              <div className="col text-end">
                <Link
                  className="close cursor-pointer"
                  to={`${(updatedRoute !== '') ? updatedRoute : '/'}`}
                  onClick={this._onLogout}
                >
                  Log Out
                </Link>
              </div>
            </div>
          </div>
          <div className="left-menu">
            <ul
              className="list-unstyled menu"
              style={{
                marginBottom: '2rem'
              }}
            >
              {
                (menuVisible === true)
                && (
                  <li>
                    <button
                      id="sideMenuTeamsListEle"
                      className="btn btn-collapse collapsed"
                      data-bs-toggle="collapse"
                      data-bs-target="#home-collapse"
                      aria-expanded="false"
                      type="button"
                    >
                      Change Team
                      <i className="fas fa-chevron-down" />
                    </button>

                    <div className="collapse" id="home-collapse">
                      <ul className="toggle-nav-list list-unstyled">
                        {
                          offices.map((value, key) => (
                            <div key={key}>
                              <li>
                                <h6 className="dropdown-header" id={`${value.id}`}>
                                  {`${value.name} ${serverUrl !== value.server ? '(Requires Logout)' : ''}`}
                                </h6>
                              </li>
                              {
                                value.teams.map((team, index) => (
                                  <li
                                    key={index}
                                    className={classNames('sub-link cursor-pointer', { 'active-sub': user.office === value.id && user.team === team.id })}
                                  >
                                    <Link
                                      onClick={() => this._onChangeTeam(
                                        value.territoryId,
                                        value.id,
                                        team.id,
                                        team,
                                        serverUrl !== value.server,
                                        true
                                      )}
                                    >
                                      {team.name}
                                    </Link>
                                  </li>
                                ))
                              }
                            </div>
                          ))
                        }
                      </ul>
                    </div>
                  </li>
                )
              }

              <li className={classNames({ 'active-sub': menu.length > 0 && menu[0] === 1 })}>
                <Link className="cursor-pointer" onClick={this._onClickCases}>
                  Cases
                </Link>
              </li>

              {
                accessObject?.isSalesMetrics && accessObject?.salesAccess ? (
                  <li className={classNames({ 'active-sub': menu.length > 0 && menu[0] === 11 })}>
                    <Link className="cursor-pointer" onClick={this._onClickSalesMetrics}>
                      Sales Metrics
                    </Link>
                  </li>
                ) : null
              }

              <li className={classNames({ 'active-sub': menu.length > 0 && menu[0] === 2 })}>
                <Link className="cursor-pointer" onClick={this._onClickBilling}>
                  Billing
                </Link>
              </li>

              <li className={classNames({ 'active-sub': menu.length > 0 && menu[0] === 3 })}>
                <Link className="cursor-pointer" onClick={this._onClickReports}>
                  Documents & Reports
                </Link>
              </li>

              <li className={classNames({ 'active-sub': menu.length > 0 && menu[0] === 10 })}>
                <Link
                  className="cursor-pointer"
                  style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}
                  onClick={this._onClickNotifications}
                >
                  Notifications
                  {
                    totalUnread !== undefined
                      ? totalUnread > 0
                        ? (
                          <span
                            style={{
                              backgroundColor: '#FF0000',
                              borderRadius: '50%',
                              width: '20px',
                              height: '20px',
                              fontSize: '12px',
                              textAlign: 'center',
                              color: '#FFFFFF',
                            }}
                          >
                            {totalUnread < 100 ? totalUnread : '99+'}
                          </span>
                        )
                        : null
                      : null
                  }
                </Link>
              </li>

              <li className={classNames({ 'active-sub': menu.length > 0 && menu[0] === 4 })}>
                <Link className="cursor-pointer" onClick={this._onClickInventory}>
                  Inventory
                </Link>
              </li>

              {
                isDER === true
                && (
                  <li className={classNames({ 'active-sub': menu.length > 0 && menu[0] === 9 })}>
                    <Link className="cursor-pointer" onClick={this._onClickDers}>
                      Device Experience Reports
                    </Link>
                  </li>
                )
              }

              <li className={classNames({ 'active-sub': menu.length > 0 && menu[0] === 12 })}>
                <Link className="cursor-pointer" onClick={this._onClickSurgeonNotes}>
                  Surgeon Notes
                </Link>
              </li>

              <li className={classNames({ 'active-sub': menu.length > 0 && menu[0] === 5 })}>
                <Link className="cursor-pointer" onClick={this._onClickPreferences}>
                  Preferences
                </Link>
              </li>

              <li className={classNames({ 'active-sub': menu.length > 0 && menu[0] === 6 })}>
                <Link className="cursor-pointer" onClick={this._onClickSyncData}>
                  Sync Data
                </Link>
              </li>

              <li className={classNames({ 'active-sub': menu.length > 0 && menu[0] === 7 })}>
                <Link className="cursor-pointer" onClick={this._onClickCalendarFeed}>
                  Calendar Feed
                </Link>
              </li>

              <li className={classNames({ 'active-sub': menu.length > 0 && menu[0] === 8 })}>
                <Link className="cursor-pointer" onClick={this._onClickSettings}>
                  Settings
                </Link>
              </li>

              <li className="d-none">
                <Link
                  to={`${(updatedRoute !== '') ? updatedRoute : '/'}`}
                  onClick={this._onLogout}
                >
                  Log Out
                </Link>
              </li>

            </ul>

            <div className="row">
              <div className="col text-center">
                <Link
                  to="#"
                  className="btn btn-sm btn-theme-alt btn-theme-outline-alt"
                  onClick={
                    (e) => {
                      window.location.href = mailBody;
                      e.preventDefault();
                    }
                  }
                >
                  Email Support
                </Link>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default withFirstLoginSessionToken(
  withScanInventory(
    withCaseFilter(
      withSelectCaseDate(
        withCalendarFilter(
          withTeam(
            withOnline(
              withNotify(
                withLoader(
                  withServerUrl(
                    withUser(
                      withMenu(
                        withScanInventoryScanner(
                          withUpdatedRoute(
                            withAutoLogin(
                              withThemeColor(
                                Sidebar
                              )
                            )
                          )
                        )
                      )
                    )
                  )
                )
              )
            )
          )
        )
      )
    )
  )
);
